import './DeleteCompanyCol.scss';
import React, {useContext, useState} from 'react';
import {i18n} from '../../../../Utils/i18n/i18n';
import {Button} from '../../../Form/Button/Button';
import {buttonColors} from '../../../Pickers/InputTheme';
import {GridReactContext} from '../../../../Utils/DataGridWrapper/GridContext';
import {DeleteCompanyModal} from './DeleteCompanyModal';

/**
 * Per-company table cell: a Delete button that opens the type-to-confirm
 * DeleteCompanyModal. Refreshes the grid after a successful deletion.
 *
 * @param {object} props
 * @param {object} props.company - The company row
 */
export const DeleteCompanyCol = ({company}) => {
    const gridContext = useContext(GridReactContext);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleDeleted = () => {
        setIsModalOpen(false);
        gridContext.triggerTableRefresh();
    };

    return <div className="DeleteCompanyCol">
        <Button color={buttonColors.GREY}
                size="small"
                text={i18n.translate('superAdmin.customersTable.deleteCompany.button')}
                onClick={() => setIsModalOpen(true)}/>
        {isModalOpen && <DeleteCompanyModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onDeleted={handleDeleted}
            company={company}/>}
    </div>;
};
